import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-specilizationform',
  templateUrl: './specilizationform.component.html',
  styleUrls: ['./specilizationform.component.css']
})
export class SpecilizationformComponent implements OnInit {
title =  'Specilization Details';
data : any = {};
formInvalid : boolean = false;
d : any = {};
fileToUpload: File = null;

SP_Id : number;
mode : string;
ActiveDetailsList: any=[];
ActiveDetails: any=[];
ActiveDetail: any=[];
ActiveDetai: any=[];
Active: any=[];
ActiveDistrict: any=[];
photoImageUrl: any;
AS_Photo: string;
Activespili: any=[];
  constructor(public service : UserService,private router: Router,private route: ActivatedRoute,  private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetAllQualification();
    this.route.params.subscribe(params => {      
      this.SP_Id = params['SP_Id'];  
      this.mode  =   params['mode'];   
        
        if(this.SP_Id > 0){
          this.getbyid(this.SP_Id)
        }    
        
    });

    if(this.mode=='view'){
      this.title = "View Specilization";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Specilization";
    } 
   
  }
  //   successNotification(){
  // {
  //   Swal.fire({
  //     position: 'top-end',
  //     title: 'Do You Want To Save?',
  //     text: '',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   }).then((result) => {
  //     if (result.value) {
  //       Swal.fire(
          
  //         'Data Saved Successfully..',
  //                 )
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire(
          
  //         'Entered Data will be Discarded..',
  //       )
  //     }
  //   })
  // }
  GetAllQualification(){
    //alert('Inside');
    
    
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.Getallspicilization();
      this.data.subscribe(
        (response: any) => {
          this.ActiveDetail = response;
        document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
  

  SaveDistrict(Distict: NgForm){
        
    if(Distict.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.service.Postspicilization(Distict.value);    
            this.data.subscribe(
            (response) => {
              Distict.reset();
              Distict.resetForm();
              Distict.form.markAsPristine();
              Distict.form.markAsUntouched();        
              swal('Success!', 'specilization Added Successfully .', 'success');
              this.router.navigate(['/home/specilization']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }
  cancel(){
    this.d.district_name="";
  }
        
            

                    
    
 
  UpdateDistrict(District: NgForm) {  
    this.data = this.service.updatespicilization(District.value,this.SP_Id);
   this.data.subscribe(
     (response) => {
      District.reset();
      District.resetForm();
      District.form.markAsPristine();
      District.form.markAsUntouched();           
                   
       swal('Success!', 'specilization updated Successfully .', 'success');
       
       this.router.navigate(['/home/specilization']) ;
       document.getElementById('loader-spinner').style.display = "none";            
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
       }
     });   
}
getbyid(SP_Id) {
  {
    
   // this.a.Image_path=this.photoImageUrl;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getbyactiveForm(SP_Id);
    this.data.subscribe(
      (response: any) => {
      this.d = response;
       document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

}
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/specilization/specilizationform/specilizationform.component.ts